<template>
    <div>
        <vx-card v-can="'view-project-brief'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters"
            class="user-list-filters mb-8" :collapse-action="true">
            <div class="vx-row">
                <div class="vx-col md:w-1/5 sm:w-full w-full">
                    <label class="text-sm opacity-100 text-bold">General</label>

                    <vs-input type="search" placeholder="Search.." v-model="filters['search']"
                        class="mb-4 md:mb-0 w-full" />
                </div>
                <div class="vx-col md:w-1/5 sm:w-full w-full">
                    <label class="text-sm opacity-100 text-bold">Status</label>
                    <v-select :clearable="true" placeholder="" v-model="filters['status']"
                        :options="['Pending', 'Completed']" :dir="$vs.rtl ? 'rtl' : 'ltr'"></v-select>
                </div>
            </div>
            <div class="vx-row mt-5">
                <div class="vx-col w-full ml-auto">
                    <vs-button class="float-right mr-4" size="small" color="danger" type="border" icon-pack="feather"
                        v-on:click="filters = {}">CLEAR</vs-button>
                </div>
            </div>
        </vx-card>
        <vx-card no-shadow>
            <vs-button class="float-right mb-2" @click.stop="onClickCreateEnquiry">Create new enquiry</vs-button>
            <vs-table :data="data_list">

                <template slot="thead">
                    <vs-th width="15%">ENQUIRY CODE</vs-th>
                    <vs-th width="15%">CREATED DATE/BY</vs-th>
                    <vs-th width="15%">ENQUIRY NAME</vs-th>
                    <vs-th width="10%">CUSTOMER USER</vs-th>
                    <vs-th width="20%">NOTES</vs-th>
                    <vs-th width="15%">STATUS</vs-th>
                    <vs-th width="10%">ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr @click.native="onClickUpdateEnquiry(data[indextr].id)" :key="indextr"
                        v-for="(tr, indextr) in data" class="cursor-pointer">

                        <vs-td :data="data[indextr].code">
                            {{ data[indextr].code }}
                        </vs-td>

                        <vs-td :data="data[indextr].created_at">
                            {{ __dateTimeFormatter(data[indextr].created_at) }} <br>
                            {{ data[indextr].created_by }}
                        </vs-td>

                        <vs-td :data="data[indextr].name">
                            {{ data[indextr].name }}
                        </vs-td>

                        <vs-td>
                            {{ data[indextr].customer_user ? data[indextr].customer_user.first_name : 'N/A' }}
                        </vs-td>

                        <vs-td>
                            {{ data[indextr].notes || 'N/A' }}
                        </vs-td>

                        <vs-td :data="data[indextr].status">
                            <vs-chip transparent :color="data[indextr].status === 'Completed' ? 'primary' : ''">
                                {{ data[indextr].status }}
                            </vs-chip>
                        </vs-td>

                        <vs-td>
                            <div class="vx-row">
                                <vx-tooltip class="mr-2" text="VIEW/UPDATE ENQUIRY" position="top">
                                    <vs-button @click.stop="onClickUpdateEnquiry(data[indextr].id)" size="small"
                                        color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                                </vx-tooltip>
                            </div>
                        </vs-td>
                    </vs-tr>
                </template>

            </vs-table>
            <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20" :max-items="perPage"
                description-body="Rows per page" description-connector="of" description-title="Records" description
                :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0" v-model="page"
                class="p-5">
            </vs-pagination>
        </vx-card>
        <CreateCustomerInquiryPopUp ref="createCustomerInquiryPopUp" v-on:refreshData="fetchLeadEnquiries" />
    </div>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const Customerepository = RepositoryFactory.get('customer');

import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import CreateCustomerInquiryPopUp from '@/components/popups/customer/customer-enquiries/CreateCustomerInquiryPopUp.vue';
import { defaultPagination, perPageList } from "@/constants/config";
import Filter from '@/mixins/filter';
export default {
    name: 'CustomerEnquiriesList',
    data() {
        return {
            id: '',
            data_list: [],
            filters: {},
            page: 1,
            total: 0,
            meta: {},
            sort: '',
            perPage: defaultPagination,
            descriptionItems: perPageList,
        }
    },
    components: {
        'v-select': vSelect,
        CreateCustomerInquiryPopUp,
    },
    mixins: [SuccessMessage, ErrorMessages, Filter],
    methods: {
        async fetchLeadEnquiries() {
            try {
                const { data } = await Customerepository.getListOfCustomerEnquiries(this.id, this.filterQuery, this.page, this.perPage)
                this.data_list = data.data
                this.meta = data.meta
            } catch (error) {
                this.convertAndNotifyError(error);
            }
        },
        onClickCreateEnquiry() {
            this.$refs.createCustomerInquiryPopUp.openPopup()
        },
        onClickUpdateEnquiry(site_id) {
            this.$refs.createCustomerInquiryPopUp.openPopup(site_id)
        },
        changePage(index) {
            this.perPage = this.descriptionItems[index]
        },
        filterQueryUpdate() {
            this.fetchLeadEnquiries()
        },
    },
    async mounted() {
        this.id = this.$route.params.id
        await this.fetchLeadEnquiries()
    },
    watch: {
        page() {
            this.fetchLeadEnquiries()
        },
        perPage() {
            this.fetchLeadEnquiries()
        }
    },
}
</script>
<style lang="">
    
</style>